<div class="hover-container">
  <div class="d-flex pointer ddl-tooltip" [attr.data-toggle]="'modal'"
    [attr.data-target]="'#stocklist-' + itemId + rowType" (click)="handleClick()" data-toggle="modal">
    <i class="far fa-chart-line font-primary align-self-center"></i>

    <!-- Lablel if required -->
    <p class="mb-0 font-bold font-14 font-primary pl-2" *ngIf="label">{{ label }}</p>
  </div>
  <div class="modal fade" tabindex="-1" role="dialog" [id]="'stocklist-' + itemId + rowType"
    [attr.aria-labelledby]="itemId" [attr.aria-hidden]="false">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="stopInnerClick(this)">
      <div class="modal-content">
        <div class="sales-history-wrapper text-left">
          <div class="sales-history-header">
            <div class="sales-history-top">
              <h4 [id]="itemId">Historical sales/reorder trend</h4>
              <i class="font-18 far fa-times font-gray-55 pointer p-1" data-dismiss="modal" aria-label="Close"
                (click)="openClose(this)"></i>
            </div>
          </div>
          <div class="sales-history-body-content">
            <div class="row">
              <div class="col-3">
                <div class="sales-history-box-wrapper">
                  <div class="sales-history-box">
                    <div class="box-icon align-self-center d-none">
                      <i class="fal fa-calendar-alt"></i>
                    </div>
                    <div class="box-content">
                      <div class="box-heading">Avg. monthly sales</div>
                      <div *ngIf="salesTrendData?.dateList?.length" class="box-value">
                        {{ salesTrendData?.monthlySales }}
                      </div>
                    </div>
                  </div>

                  <div class="sales-history-box">
                    <div class="box-icon align-self-center d-none">
                      <i class="fal fa-calendar-week"></i>
                    </div>
                    <div class="box-content">
                      <div class="box-heading">Avg. weekly sales</div>
                      <div *ngIf="salesTrendData?.dateList?.length" class="box-value">
                        {{ salesTrendData?.weeklySales }}
                      </div>
                    </div>
                  </div>

                  <div class="sales-history-box">
                    <div class="box-icon align-self-center d-none">
                      <i class="fal fa-calendar-day"></i>
                    </div>
                    <div class="box-content">
                      <div class="box-heading">Avg. daily sales</div>
                      <div *ngIf="salesTrendData?.dateList?.length" class="box-value">
                        {{ salesTrendData?.dailySales }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-9">
                <div class="sales-history-body">
                  <div (click)="stopInnerClick(this)" class="sales-history-chart-wrapper position-relative">
                    <div class="line-chart-img chart-img" tooltipStyleClass="sale_tooltip" tooltipPosition="top"
                      pTooltip="This displays the sales trend"></div>
                    <div class="bar-chart-img chart-img" tooltipStyleClass="sale_tooltip" tooltipPosition="top"
                      pTooltip="This displays the purchasing trend"></div>
                    <canvas baseChart id="sales-trend-chart" [datasets]="chartData" [labels]="chartLabels"
                      [options]="chartOptions" [plugins]="lineChartPlugins" [colors]="chartColors"
                      [chartType]="chartType" (chartHoverlineChartPlugins)="chartHovered($event)"
                      (chartClick)="chartClicked($event)"></canvas>
                    <div id="legend-container"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Reorder trend -->
          <div class="ordering-table-wrapper py-0" *ngIf="stockReorderList.length > 0">
            <div class="ordering-table-header">
              <h5>Reorder trend</h5>
            </div>
            <div class="ordering-table-body mt-2">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" *ngFor="let columns of reOrderCol" [ngClass]="columns.className">
                      <div>
                        {{ columns.header }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody (scroll)="onScrollReOrder($event)" #reOrderContainer>
                  <tr *ngFor="let item of stockReorderList">
                    <td class="sup-date">
                      <div>
                        {{ item?.date | date : 'MMM d, yyyy' }}
                      </div>
                    </td>
                    <td class="quantity">
                      <div>
                        {{ item?.quantity }}
                      </div>
                    </td>
                    <td class="poNumber pointer" (click)="openPO(item)">
                      <div>
                        {{ item?.poNumber }}
                      </div>
                    </td>
                    <td class="supplier-name">
                      <div class="text-truncate" tooltipPosition="top" [pTooltip]="item?.supplierName">
                        {{ item?.supplierName }}
                      </div>
                    </td>
                    <td class="cost">
                      <div>
                        {{ item?.cost }}
                      </div>
                    </td>
                    <td class="core">
                      <div>
                        {{ item?.core }}
                      </div>
                    </td>
                    <td class="supplierInvoiceDate">
                      <div>
                        {{ item?.supplierInvoiceDate | date : 'MMM d, yyyy' }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Sales trend -->
          <div class="ordering-table-wrapper py-0" *ngIf="stockList.length > 0">
            <div class="ordering-table-header">
              <h5>Sales trend</h5>
            </div>
            <div class="ordering-table-body mt-2 sales-trends">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" *ngFor="let columns of salesCol" [ngClass]="columns.className">
                      <div>
                        {{ columns.header }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody (scroll)="onScrollSales($event)" #salesContainer>
                  <tr *ngFor="let item of stockList">
                    <td class="sup-date">{{ item?.date | date : 'MMM d, yyyy' }}</td>
                    <td class="quantity">{{ item?.quantity }}</td>
                    <td class="roNumber pointer" (click)="openRO(item)">{{ item?.roNumber }}</td>
                    <td class="price">{{ item?.price }}</td>
                    <td class="cost">{{ item?.cost }}</td>
                    <td class="core">{{ item?.core }}</td>
                    <td class="supplierInvoiceDate">{{ item?.invoiceDate | date : 'MMM d, yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
